module.exports = __webpack_public_path__ + "static/img/demmmuy.d8e25b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/png-img/demmmuy.jpg
// module id = 1326
// module chunks = 4